import axiosHttp from "services/axiosHttp";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchSubChannelStatus = createAsyncThunk("fetchSubChannelStatus", async ({ identifier }) => {
	const response = await axiosHttp.get(`statuses?keyword=${identifier}`);
	return response.data.data;
});

const SubChannelStatusSlice = createSlice({
	name: "SubChannelStatusSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
		page: 1,
		total: 0,
	},

	extraReducers: (builder) => {
		builder.addCase(fetchSubChannelStatus.pending, (state) => {
			state.isLoading = true;
		});

		builder.addCase(fetchSubChannelStatus.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
			state.page = action.payload.page;
			state.total = action.payload.total;
		});
		builder.addCase(fetchSubChannelStatus.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export default SubChannelStatusSlice.reducer;
